import React, { useEffect, useState } from 'react';
export const DaysInput = (props) => {
	const { item, index, style, height,onBlur,value } = props
	const { filter, upperCase, maxLength=100, disabled } = props
	const [stateValue, setStateValue] = useState(value)
	const handleChange = (e) => {
    let val = e.target.value
    if (filter) val = filter(val)
    if (upperCase && typeof val === 'string') val = val.toUpperCase()
    if ((val + '').length <= maxLength && !disabled) {
      setStateValue(val)
    }
  }
	useEffect(() => {
    setStateValue(value);
  }, [value]);
	return (
    <div className="input-witth-label" style={{ ...style, height: height }}>
      <input
        id={`cmDaysInput-${index}`}
        type="text"
        style={{ width: '50%', paddingRight: '5px', color: '#444', background: '#fff' }}
        value={stateValue}
				onChange={(e) => handleChange(e)}
        onBlur={(e) => onBlur && onBlur(e)}
      />
      <div
        style={{
          width: '50%',
          backgroundColor: '#f0f0f0',
          display: 'flex',
          alignItems: 'center',
          borderTopRightRadius: '6px',
          borderBottomRightRadius: '6px',
        }}
      >
        <span style={{ margin: '0 auto', color: '#666' }}>Days</span>
      </div>
    </div>
  )
}